import { DownCaret, LeftCaret, RightCaret } from "components/WebDesigner/Icons/Carets";
import {  useCallback, useEffect, useRef, useState } from "react";
import "../../Styles/SCSS/_set_library.scss";
import "../../Styles/panel.menus.css";

import "vagaro-website-rendering/src/components/Styles/page.content.css";
import CreateStylePreviewImage from "components/WebDesigner/CreateStylePreviewImage";
import FontGenerator from "./FontGenerator";
import { GetAllSetsFromStyles } from "./ExisitingStyleParsor";
import { useSelector } from "react-redux";

import ColorInputField from "components/WebDesigner/StyleInputs/ColorInputField";
import { AttributeDefinition, AttributeInputType, AttributeTargetType } from "components/WebDesigner/Data/WBData";
import { AttributeCollection, getNodeComponentAttributeValue,  setNodeComponentAttributeValue, setNodeStyleAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { DefaultSiteData } from "components/WebDesigner/Data/SiteData";
import  { GetFontOptions, browserSafeFonts, googleFonts } from "components/WebDesigner/StyleInputs/FontField";
import SelectField from "components/WebDesigner/StyleInputs/SelectField";
import HamburgerIcon from "vagaro-website-rendering/src/components/Icons/Hamburger";
import { DndContext, closestCenter, KeyboardSensor, PointerSensor, useSensor, useSensors, DragStartEvent, DragEndEvent, } from '@dnd-kit/core';
import { arrayMove, SortableContext, sortableKeyboardCoordinates, rectSortingStrategy, useSortable } from '@dnd-kit/sortable';
import {  ChangeSetSequence, DeleteSetItem, EditSetItem, GetSetCategories, GetSetList, SetSetItemPublicOrPrivate, SetType } from "./SetLibraryAPI";
import Loader from "components/Common/Loader";
import { AlertConfirm } from "components/WebDesigner/ConfirmationPopups";
import { Dropdown } from "react-bootstrap";
import { OpenSavSetMenu, SetSaveType } from "./SaveSetPopUp";
import ReactDOM from "react-dom";
import { CreateBlankLayoutNode } from "components/WebDesigner/WBCanvas";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";
import PreviewScreen from "components/WebDesigner/PreviewScreen";
import { attributeTypes, componentAttributeTypes } from "vagaro-website-rendering/src/components/Definitions/AttributeTypes";
import Toast, { CustomColorToast } from "components/WebDesigner/Toast";
import XIcon from "vagaro-website-rendering/src/components/Icons/XIcon";
import { OpenBusinessTypePopup } from "./BusinessTypeFilter";
import { CheckItem } from "components/WebDesigner/StyleInputs/CategorySelector";
import imageCompression from 'browser-image-compression';
import { UploadImage } from "components/WebDesigner/Utilities/FileUploadUtility";

import SetLayoutList from "./SetLayoutList";

import { utils, LoginUserType, MobileCallbackTypes } from "../../utils/Utils";

export const setsForAdminOnly = false;

export type StyleSet = {
    id:string,
    items:string[],
    rank:number,
    index?:number,
    isPrivate?:boolean,
    categories:string[],
}

export function CreateStyleSet (id:string,content:string[],rank:number = 0,isPrivate = true,categories = [],index = 0){
    let set:StyleSet = {id:id,items:content,rank:rank,isPrivate:isPrivate,categories:categories,index:index};
    return set;
}

export function GetAccessData(access_token:string,generate_time:number,businessId:string,cdnURL:string,isAdmin:boolean,ReactUserID:number){

  
    let userContext = {...DefaultSiteData.userContext};
    userContext.accessToken = access_token;
    userContext.tokenExpiresAt = generate_time + 30 * 60000; //20 minutes reducing time as 40 was still expiring.;
    userContext.businessId = businessId;
    userContext.userId = ReactUserID;
    userContext.cdnURL = cdnURL; //@TODO figure out why redux CDN is not working
    userContext.isAdmin = isAdmin;
    userContext.layoutId = "sets";
    return userContext;
}

export default function SetLibraryMenu() {





    const isProApp = utils.IsFromProApp();


    const { BusinessID,UserType,ReactBusinessId,ReactUserID } = useSelector((state: any) => state.Business);
    
    const { access_token, generate_time } = useSelector((state: any) => state.Token);

    let testCDN = window.location.href.indexOf("vagaro.com") > 0 ? "https://d396040dc4cf62cf5770-d11e112dbdab6afc64c448f17b56c3c3.ssl.cf2.rackcdn.com": "https://f745786de3dd98dac855-36e09dc6f87385bab9d0e7ff5c0d38c7.ssl.cf2.rackcdn.com"

    const [isLoading,setIsLoading] = useState<boolean>(true);

    const [compressionProgress,setCompressionProgress] = useState<number[]>([100,100,100,100]);
    const progressRef = useRef([...compressionProgress]);
    const progressCountRef = useRef(0);


    const isAdmin =   (UserType === LoginUserType.VagaroAdmin&&ReactBusinessId<=0)//window.location.href.toLowerCase().indexOf("admin") > 0; //

    const userContext = useRef(GetAccessData(access_token,generate_time,BusinessID,testCDN,isAdmin,ReactUserID));


    const [selectedTab, setSelectedTabVal] = useState<string>("Colors");

    const setSelectedTab = (tab:string)=>{

        if(contentContainerRef.current)
            contentContainerRef.current.scrollTop = 0;
  


        setSelectedTabVal(tab);
    }



    const defaultColors = ["#222222","#444444","#666666","#888888","#aaaaaa"];
    const defaultImages =   [   
        "https://images.unsplash.com/photo-1640346876473-f76a73c71539?q=80&w=2127&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1640346876473-f76a73c71539?q=80&w=2127&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1640346876473-f76a73c71539?q=80&w=2127&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
        "https://images.unsplash.com/photo-1640346876473-f76a73c71539?q=80&w=2127&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    ]
    const defaultFonts = ["proxima-nova","proxima-nova"];

    const [selectedColors, setSelectedColors] = useState<StyleSet>( CreateStyleSet("1",defaultColors));
    const [selectedImages, setSelectedImages] = useState<StyleSet>(
        CreateStyleSet("2",
      defaultImages,0)
    );
    const [selectedFonts, setSelectedFonts] = useState<StyleSet>(CreateStyleSet("0",defaultFonts));

    const [allColors, setAllColors] = useState<StyleSet[]>([]);
    const [allImages, setAllImages] = useState<StyleSet[]>([]); 
    const [allFonts, setAllFonts] = useState<StyleSet[]>([]);

    const [selecteColorCategories,setSelectedColorCategories] = useState<string[]>([]);
    const [selectedImageCategories,setSelectedImageCategories] = useState<string[]>([]);
    const [selectedFontCategories,setSelectedFontCategories] = useState<string[]>([]);

    const [availableColorCategories,setAvailableColorCategories] = useState<string[]>([]);
    const [availableImageCategories,setAvailableImageCategories] = useState<string[]>([]);
    const [availableFontCategories,setAvailableFontCategories] = useState<string[]>([]);

    const [allBusinessTypes,setAllBusinessTypes] = useState<any[]>([]);
    const [isFirstLoad,setIsFirstLoad] = useState<boolean>(true);
    const [showPrivate,setShowPrivate] = useState<boolean>(userContext.current.isAdmin??false);
    const [showPublic,setShowPublic] = useState<boolean>(true);
    const [adminFilterOpen,setAdminFilterOpen] = useState<boolean>(false);

    let selectedSetType = (selectedTab==="Fonts")?SetType.Font:(selectedTab==="Images")?SetType.Image:SetType.Color;

   let filteredSets = (selectedTab==="Fonts")?allFonts:(selectedTab==="Images")?allImages:allColors;
   filteredSets = filteredSets.filter((set:StyleSet) => {
    if((set.isPrivate&&!showPrivate) || (!set.isPrivate&&!showPublic))
        return false;
   
    return true;
   });
    
let moreSelected = false;

//don't break right now @todo add dependencies
//eslint-disable-next-line
useEffect(()=>{
    if(isProApp){
        switch(selectedTab){
            case "Colors":
               utils.CallBackGivenToMobileApp(MobileCallbackTypes.FilterWithBack, "Step 1: Colors", 1, 60);
                break;
            case "Images":
                utils.CallBackGivenToMobileApp(MobileCallbackTypes.FilterWithBack, "Step 2: Images", 1, 60);
                setSelectedImages(selectedImages);
                break;
            case "Fonts":
                utils.CallBackGivenToMobileApp(MobileCallbackTypes.FilterWithBack, "Step 3: Fonts", 1, 60);
                setSelectedFonts(selectedFonts);
                break;
            case "Layout":
                utils.CallBackGivenToMobileApp(MobileCallbackTypes.FilterWithBack, "Final Step: Layout", 1, 60);
                setSelectedFonts(selectedFonts);
                break;
        
        }
    }
})

if(selectedTab=="Images"&& selectedImageCategories.length>0){

    let filtered = availableImageCategories;

    for(let i = 0;i<selectedImageCategories.length;i++){
        if(filtered.findIndex((cat:any) => cat.id == selectedImageCategories[i])>6){
            moreSelected = true;
            break;
        }
    }
}



    let chooseMessage = "Choose a color palette that’s crafted by our designers. You can always change this later in Site Styling.";
    let stepMessage = "Step 1: ";
    if(selectedTab==="Fonts"){
        chooseMessage = "Choose a font pair that’s curated by our designers. You can always change this later in Site Styling.";
        stepMessage = "Step 3: ";
    }
    else if(selectedTab==="Images"){
        stepMessage = "Step 2: "
        chooseMessage = "Choose an image set that is tailored to your industry. You can always swap out the images later.";

    }
    else if(selectedTab === "Layout"){
        stepMessage = "Final Step: "
        chooseMessage = "Choose a handcrafted layout that best fits your content. You can always customize the layout later in your Settings.";
    }

    const onMakeSelection = ()=>{

        let dom = document.querySelector(".style-preview-card");

        if(dom){
            dom.animate([{ transform: "scale(1.01)" }, { transform: "scale(.99)" },{ transform: "scale(1)" }], {
                fill: "forwards",
                easing: "ease-in-out",
                duration: 200
            }
            );
        }
       
    }

    const CurrentAvailabelCats = ()=>{
        if(selectedTab==="Fonts")
            return availableFontCategories;
        else if(selectedTab==="Images")
            return availableImageCategories;
        else if(selectedTab==="Colors")
            return availableColorCategories;
        else
            return [];

    }   

    const NextTab = ()=>{
        if(selectedTab==="Fonts")
            setSelectedTab("Colors");
        else if(selectedTab==="Images")
            setSelectedTab("Fonts");
        else if(selectedTab==="Colors")
            setSelectedTab("Images");
    }

    const PrevTab = ()=>{
        if(selectedTab==="Fonts")
            setSelectedTab("Images");
        else if(selectedTab==="Images")
            setSelectedTab("Colors");
        else if(selectedTab==="Colors")
            setSelectedTab("Fonts");
        else if(selectedTab==="Layout")
            setSelectedTab("Fonts");
        
    }

    const SelectedCatagories = ()=>{
        if(selectedTab==="Fonts")
            return selectedFontCategories;
        else if(selectedTab==="Images")
            return selectedImageCategories;
        else if(selectedTab==="Colors")
            return selecteColorCategories;
        else
            return [];
    }

    const SelectedSet = ()=>{
        if(selectedTab==="Fonts")
            return selectedFonts;
        else if(selectedTab==="Images")
            return selectedImages;
        else if(selectedTab==="Colors")
            return selectedColors;
        else
            return selectedFonts;
    }

    let showProgress = false;
    let progress = 0;
    

    for(let i = 0;i<compressionProgress.length;i++){
        if(compressionProgress[i]<100){
            showProgress = true;
          
  
        }

        progress+=compressionProgress[i];
    }

    

    if(showProgress){

        let inverse = (4-progressCountRef.current)*100; //remove the 100 from each progress thats not being counted
        progress-=inverse;
        progress = Math.floor( progress / progressCountRef.current );
    }


    const contentContainerRef = useRef<HTMLDivElement>(null);
    //used for loading all style sets from existing styles @todo remove before production
    const [loadingString,setLoadingString] = useState<string>("Load All");
    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );



    const loadAllStyleSetData = async () => {
        await GetAllSetsFromStyles(access_token, (data: any) => { 

            
            let colors = data.colorPairs;
            let images = data.imagePairs;
            let fonts = data.fontPairs;



            setAllColors(colors.map((colorSet:string,index:number) => {
                return CreateStyleSet(`${index}-color`, colorSet.split(","));
            }));
            setAllImages(images.map((imageSet:string,index:number) => {

                // let images = imageSet.split(",");



                return CreateStyleSet(`${index}-font`, imageSet.split(","));
            }));
            
            let newfonts:StyleSet[] = fonts.map((fontSet:string,index:number) => { //replace missing fonts
                let split = fontSet.split(",");
                if(!googleFonts.includes(split[0])&&!browserSafeFonts.includes(split[0]))
                    split[0] = "proxima-nova";
                if(!googleFonts.includes(split[1])&&!browserSafeFonts.includes(split[1]))
                    split[1] = "proxima-nova";

                return CreateStyleSet(`${index}-font`,split);
            })

            newfonts = newfonts.filter((fontSet:StyleSet) => { // remove duplicates


                let index = newfonts.findIndex((set:StyleSet) => {
                    return set.items[0] === fontSet.items[0] && set.items[1] === fontSet.items[1];
                });
                let lastIndex = newfonts.findIndex((set:StyleSet,index) => {
                    return set.items[0] === fontSet.items[0] && set.items[1] === fontSet.items[1];
                });

                return index === lastIndex;


            });

            setAllFonts(newfonts);

            setLoadingString("Success!");


        }, (data: any) => { 
            setLoadingString("loading: " +data);
      
        });

    }

    const OpenPreview = ()=>{

        let styling = {...DefaultSiteData.siteStyling};

        styling.colorPallet = [...styling.colorPallet];
        for(let i = 0;i<selectedColors.items.length;i++){
            styling.colorPallet[i] = selectedColors.items[i];
        }

        styling.imageMapping = [...styling.imageMapping];
        if(selectedFonts.items.length>1){
            styling.fontPrimary = selectedFonts.items[0];
            styling.fontSecondary = selectedFonts.items[1];
        }
        setNodeStyleAttributeValue(styling.buttonPrimary,0,"borderRadius","5px");

        let data= {...DefaultSiteData};
        data.siteStyling = styling;

        let nav = CreateBlankLayoutNode(wBComponentTypeNames.navigationBar);

        setNodeComponentAttributeValue(nav,"dropdownBg",styling.colorPallet[3]);
        let footer = CreateBlankLayoutNode(wBComponentTypeNames.footer);
        let node = CreateBlankLayoutNode(wBComponentTypeNames.pageRoot);
        let sectiona = CreateBlankLayoutNode(wBComponentTypeNames.section);
        let cola = CreateBlankLayoutNode(wBComponentTypeNames.column);
        setNodeStyleAttributeValue(cola,0,attributeTypes.gap,"20px");
        setNodeStyleAttributeValue(cola,0,attributeTypes.padding,"32px");
        sectiona.children = [cola];

        let heading = CreateBlankLayoutNode(wBComponentTypeNames.heading);
        heading.content = "Express Yourself";
        setNodeStyleAttributeValue(heading,0,attributeTypes.textAlign,"center");
        setNodeStyleAttributeValue(heading,0,attributeTypes.fontSize,"48px");
        setNodeStyleAttributeValue(heading,0,attributeTypes.color,"#ffffff");
        setNodeComponentAttributeValue(sectiona,componentAttributeTypes.overlayColor,styling.colorPallet[0]+"88");
        let btn = CreateBlankLayoutNode(wBComponentTypeNames.button);
        btn.content = "Book Now";
        cola.children = [heading,btn];
        setNodeStyleAttributeValue(cola,2,attributeTypes.height,"300px");

    

        let sectionb = CreateBlankLayoutNode(wBComponentTypeNames.section);
        let sectionc = CreateBlankLayoutNode(wBComponentTypeNames.section);

        setNodeComponentAttributeValue(sectionc,"reverseColumnsMobile","reverse");
        let colb1 = CreateBlankLayoutNode(wBComponentTypeNames.column);
        let colb2 = CreateBlankLayoutNode(wBComponentTypeNames.column);
        sectionb.children = [colb1,colb2];

        let hdingb1 = CreateBlankLayoutNode(wBComponentTypeNames.heading);
        hdingb1.content = "Our Story";
        setNodeStyleAttributeValue(hdingb1,0,attributeTypes.textAlign,"center");
        setNodeStyleAttributeValue(hdingb1,0,attributeTypes.fontSize,"36px");

        setNodeStyleAttributeValue(sectionb,0,attributeTypes.padding,"32px");
        setNodeStyleAttributeValue(footer,0,attributeTypes.backgroundColor,styling.colorPallet[2])
        let txt = CreateBlankLayoutNode(wBComponentTypeNames.text);
        txt.content = "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.";

        colb1.children = [hdingb1];
        colb2.children = [txt];

        setNodeStyleAttributeValue(colb1,0,attributeTypes.padding,"32px");
        setNodeStyleAttributeValue(colb2,0,attributeTypes.padding,"32px");

        let clmc = CreateBlankLayoutNode(wBComponentTypeNames.column);
        let clmc2 = CreateBlankLayoutNode(wBComponentTypeNames.column);

        setNodeStyleAttributeValue(sectionc,0,attributeTypes.padding,"32px");
       
        let img = CreateBlankLayoutNode(wBComponentTypeNames.image);
        setNodeComponentAttributeValue(img,"imageSrc",selectedImages.items[1]);
        let txt2 = CreateBlankLayoutNode(wBComponentTypeNames.text);
        txt2.content = txt.content;
        sectionc.children = [clmc2,clmc];
        clmc.children = [img];
        clmc2.children = [txt2];
        node.children = [nav,sectiona,sectionb,sectionc,footer];
        setNodeStyleAttributeValue(clmc,0,attributeTypes.padding,"32px");
        setNodeStyleAttributeValue(clmc2,0,attributeTypes.padding,"32px");
        setNodeStyleAttributeValue(sectiona,0,attributeTypes.backgroundImage,"url("+selectedImages.items[0]+")");
        setNodeStyleAttributeValue(sectiona,0,attributeTypes.height,"500px");


        const dom =  document.getElementById("OpenDialog2");
        data.userContext = userContext.current;
        const PopupClose = ()=>{
    
            if(dom){
                ReactDOM.unmountComponentAtNode(dom);
            }
        }
    

    
 
    
        ReactDOM.render(
            <>
            <div className="" style={{position:"fixed",zIndex:"1000",top:"0",left:"0",width:"100%",height:"100%",background:"rgba(0,0,0,.5)"}} onClick={PopupClose}></div>
            <PreviewScreen siteData={data} root={node} edgeSize={32}  onDismiss={PopupClose} /></>
           ,
            dom);

    }

    const loadSetData = async (setType:SetType,filters:string[]|null = null, getCats:boolean = true) => {

        if(filters == null)
        switch(setType){
            case SetType.Color:
                filters = selecteColorCategories;
                break;
            case SetType.Image:
                filters = selectedImageCategories;
                break;
            case SetType.Font:
                filters = selectedFontCategories;
                break;
            
        }

        let filterStr = filters.length>0?filters.join(","):"";

        let index = 0;
        if(getCats)
        await GetSetCategories(userContext.current,setType,(data:any) => {


            let categories = data?.data?.data??[];
            if(setType==SetType.Color)
                setAvailableColorCategories(categories);
            else if(setType==SetType.Image){
                
                setAllBusinessTypes(categories);//store categories with references to main cats (Wellness Fitness Beauty)
                categories = categories.filter((cat:any) => cat.parentCategoryId.length>2);
                setAvailableImageCategories(categories);

            }
            else if(setType==SetType.Font)
                setAvailableFontCategories(categories);
        },(error:any) => {});

        await GetSetList(userContext.current,setType,filterStr, (data:any) => {

            let list = data?.data?.data??[];

            let sets:StyleSet[] = [];

            for(let i = 0;i<list.length;i++){
                let set = list[i];
                let content = [];
                try{
                    content = JSON.parse(set.content);
                }   
                catch(e){


                    console.warn(e);
                }
                
                if(content.length>0){
                    
                    if(userContext.current.isAdmin||!set.isPrivate){
                    sets.push( CreateStyleSet(set.id,content,set.rank,set.isPrivate,set.categoryID,index));
                    index++;
                    }

                }


            }


            if(setType==SetType.Color)
                setAllColors(sets);
            else if(setType==SetType.Image)
                setAllImages(sets);
            else if(setType==SetType.Font)
                setAllFonts(sets);

        },(error:any) => {
            console.log(error);
        },ReactBusinessId);

    }

    const deleteSet = async (setType:SetType,set:StyleSet) => {

        setIsLoading(true);
        DeleteSetItem(userContext.current,setType,set.id,(data:any) => {

            let selected = SelectedSet();
            if(selected && selected.id == set.id){
                selected.id = "dlt";
            }
            reloadSetData(setType);
        },(error:any) => {
            AlertConfirm("Error deleting set, please try again");
            setIsLoading(false);
           
        });

    }

    const updateSet = async () => {
        let set = SelectedSet();

        if(set?.id){
        setIsLoading(true);

        //convert all images
        if( selectedSetType === SetType.Image){

            for(let i= 0;i<set.items.length;i++){
                let url = set.items[i];
                if(url.indexOf("base64")>0){
                    let split = url.split("base64,");

                    if(split.length<2){
                        continue; // invalid url
                    }
    
                    let base64 = split[1];
    
                    await UploadImage(userContext.current,"library-image.png",base64,(data:any)=>{ 
                        if(set)
                        set.items[i] = userContext.current.cdnURL+"/WB/sets/"+data;
                        //urls[i] = data.data.data.url;
    
                    },(error:any)=>{console.error(error);});
                }

            }

        }


        await EditSetItem(userContext.current,selectedSetType,set.id,set.items,(data)=>{

            reloadSetData(selectedSetType);
            Toast("Set updated successfully");
            
        },(error)=>{

            CustomColorToast("Error saving set","#B42318","#ffffff",<XIcon/>);
        });
        setIsLoading(false);
        }
        else{
            CustomColorToast("No set selected","#B42318","#ffffff",<XIcon/>);
        }
       
    }

    const togglePrivate = async (isPrivate:boolean,setType:SetType,set:StyleSet) => {

        setIsLoading(true);
      
        SetSetItemPublicOrPrivate(userContext.current,setType,!isPrivate,set.id,(data:any) => {
            set.isPrivate = isPrivate;
            switch(setType){
                case SetType.Color:
                    setAllColors([...allColors]);
                    break;
                case SetType.Image:
                    setAllImages([...allImages]);
                    break;
                case SetType.Font:
                    setAllFonts([...allFonts]);
                    break;
            }

            setIsLoading(false);
        },(error:any) => {
            AlertConfirm("Error changing set privacy, please try again");
            setIsLoading(false);
        });
    }

    const reloadSetData = async (setType:SetType) => {
        setIsLoading(true);
        await loadSetData(setType);
        setIsLoading(false);
    }

    const reloadSetDataWithFilters   = async (setType:SetType,filters:string[]) => {
        setIsLoading(true);
        await loadSetData(setType,filters,false);
        setIsLoading(false);
    }

    const changeSequence = async (setType:SetType,id:string,fromRank:number,toRank:number) => {
        setIsLoading(true);
        await ChangeSetSequence(userContext.current,setType,id,fromRank,toRank,(data:any) => {
            reloadSetData(setType);
        },(error:any) => {
            AlertConfirm("Error changing set sequence, please try again");
            setIsLoading(false);
        });
    }

    const loadAllSetData = async () => {
            setIsLoading(true);    
            await loadSetData(SetType.Color);
            await loadSetData(SetType.Image);
            await loadSetData(SetType.Font);
            setIsLoading(false);
            setIsFirstLoad(false);
        

    }

    useEffect(() => {

 
        loadAllSetData();

//eslint-disable-next-line
    },[]);

    const handleDragStart = useCallback((event: DragStartEvent) => {
     //eslint-disable-next-line 
    }, []);
    const handleDragCancel = useCallback(() => {
//eslint-disable-next-line
    }, []);
    const handleDragEnd = (event: DragEndEvent) => {
        const { active, over } = event;

        let newItems =   (selectedTab==="Fonts")?allFonts:(selectedTab==="Images")?allImages:allColors;

        if (active.id !== over?.id) {

            const oldIndex = newItems.findIndex((item) => item.id === active.id);
            let newIndex = newItems.findIndex((item) => item.id === over?.id);

            

            if(newIndex>=0&&oldIndex>=0){



                newItems = arrayMove(newItems, oldIndex, newIndex);

            if(selectedTab=="Colors")
                setAllColors(newItems);
            else if(selectedTab=="Images")
                setAllImages(newItems);
            else if(selectedTab=="Fonts")
                setAllFonts(newItems);

                let item = newItems.find((item) => item.id === active.id);
                let overItem = newItems.find((item) => item.id === over?.id);

                if(item && overItem)
                    changeSequence(selectedSetType,item?.id,item.rank,overItem.rank);


            }
            
        }

    
    };
          //const grad = `linear-gradient(313deg,${selectedColors.items[0]}aa,${selectedColors.items[1]}aa,${selectedColors.items[2]}aa,${selectedColors.items[3]}aa,white,white,white,white`;


        //   if(!userContext.current.isAdmin){
        //     return <div>Restricted</div>
        //   }

    if(isFirstLoad && isLoading){
        return <Loader/>
    }

    const allSelected = selectedColors.id.length>3&&selectedImages.id.length>3&&selectedFonts.id.length>3;

    if(setsForAdminOnly && !isAdmin){
        return <div>Unauthorized</div>
    }

    return (
        <>
    {showProgress && 
    <div className="w-full h-full center-all flex-column gap-med progress-container " style={{color:"white", position:"fixed",top:"0",left:"0",zIndex:50000,background:"#00000066"}}>
  
       
        <div style={{fontWeight:600,fontSize:"14px"}}>Compressing {progressCountRef.current} Image{(progressCountRef.current>1?"s":"")}</div>

            <div  className="progress-bar relative"  style={{width:"200px",height:"20px",background:"#f0f0f0",margin:"0",padding:"0",border:"2px solid white",boxShadow:"0 0 10px 10px #00000022"}}>
               <div style={{position:"absolute",fontWeight:600,color:"black",left:"90px",top:"-1px",fontSize:"12px"}} >{progress}%</div>
                    <div className="progress-bar-inner relative" style={{width:progress+"%",height:"100%",overflow:"hidden"}}>
                        <div style={{position:"absolute",fontWeight:600,color:"white",left:"90px",top:"-1px",fontSize:"12px"}} >{progress}%</div>
                    </div>
                    
                </div>
        {
        
            // compressionProgress.map((prog,i)=>{

            //     if(prog>=100)
            //         return null;
    
            //     return <div key={i} className="progress-bar relative"  style={{width:"200px",height:"20px",background:"#f0f0f0",margin:"0",padding:"0",border:"2px solid white",boxShadow:"0 0 10px 10px #00000022"}}>
            //    <div style={{position:"absolute",fontWeight:600,color:"black",left:"90px",top:"-1px",fontSize:"12px"}} >{prog}%</div>
            //         <div className="progress-bar-inner relative" style={{width:prog+"%",height:"100%",overflow:"hidden"}}>
            //             <div style={{position:"absolute",fontWeight:600,color:"white",left:"90px",top:"-1px",fontSize:"12px"}} >{prog}%</div>
            //         </div>
                    
            //     </div>
            // })
        }

    </div>

    }

        <div id="toast-root" className="set-toast" style={{position:"fixed",zIndex:"1000",left:"0",width:"100vw"}}></div>

        <div className={"set-lib flex-column "+(isProApp?"pro":"")} style={{height:"calc(100vh - 50px)"}}>
     

            {isLoading &&!showProgress&& <Loader/>}
            { <div  onClick={()=>{window.location.pathname="/"}}  style={{margin:"0",paddingTop:"12px",width:"fit-content"}} className="cursor-pointer title-with-btn py-t24 page-title-wrap flex-row" ><div className="flex-row align-center" ><div className="center-all" style={{height:".8em",width:".8em",margin:"0px .5em"}}><LeftCaret/></div><h2 className="page-title flex-row ">
                {userContext.current.isAdmin?"Set Library":"Build Your Own"}
                </h2></div></div>

                }
            <div className="set-library-menu relative flex-column set-grid"
            style={{margin:"auto",maxWidth:"1900px",height:"100%",width:"100%"}}
                // style={{backgroundImage:`linear-gradient(33deg,${selectedColors.items[0]}aa,${selectedColors.items[1]}aa,${selectedColors.items[2]}aa,${selectedColors.items[3]}aa`,backgroundAttachment:"fixed"}}
            >




                <div className="set-grid-top" style={{fontWeight:"600",padding:"0px 12px",background:"white"}}>
            {!isProApp&&
            <div className="panel-tabs justify-center"   >

                {selectedTab === "Layout"?<>
                  <div className={`tab-button thick invisible-button relative center-all vanimation-fade-in-right`} style={{opacity:"0",animationDelay:"0"}} onClick={() => {setSelectedTab("Fonts")}}><LeftCaret/>&nbsp; Theme</div>
                  <div></div>
                     <div className={`tab-button thick invisible-button relative ${selectedTab === "Layout" ? "selected" : ""}`} onClick={() => {setSelectedTab("Layout")}}> Layout</div>
                    
                     <div style={{width:"100px"}}></div>
                     </>
               :
                <>

                {allSelected&&<div style={{width:"124px"}}></div>}
                <div className={`tab-button thick invisible-button relative ${selectedTab === "Colors" ? "selected" : ""}`} onClick={() => {setSelectedTab("Colors")}}>{!userContext.current.isAdmin&&<CircleCheck isVisible={selectedColors.id.length>3}/>} Colors</div>
                <div className={`tab-button thick invisible-button relative ${selectedTab === "Images" ? "selected" : ""}`} onClick={() => {setSelectedTab("Images")}}>{!userContext.current.isAdmin&&<CircleCheck isVisible={selectedImages.id.length>3}/>} Images</div>
                <div className={`tab-button thick invisible-button relative ${selectedTab === "Fonts" ? "selected" : ""}`} onClick={() => {setSelectedTab("Fonts")}}>{!userContext.current.isAdmin&&<CircleCheck isVisible={selectedFonts.id.length>3}/>} Fonts</div>
                {/* <div className={`tab-button thick invisible-button relative ${selectedTab === "StyleList" ? "selected" : ""}`} onClick={() => {setSelectedTab("StyleList")}}>{!userContext.current.isAdmin&&<CircleCheck isVisible={selectedFonts.id.length>3}/>} Style List</div> */}
                {allSelected&&!userContext.current.isAdmin&&
                <div className={`tab-button thick invisible-button relative center-all vanimation-fade-in-left`} style={{minWidth:"124px",opacity:"0",animationDelay:"0"}} onClick={() => {setSelectedTab("Layout")}}> Layout &nbsp;<RightCaret/></div>}
                </>         
                }
            </div>
}
        <div  style={{margin:"0px 12px",width:(isProApp?"100%":"calc(100% - 58px)"),borderBottom:"1px solid #CDCDCD"}}></div>

   { isProApp&&            <div className="align-center flex-row justify-start gap-med vanimation-fade-in " key={selectedTab} style={{fontWeight:400,fontSize:"16px",lineHeight:"20px",padding:"20px 0px 16px 0px",animationDelay:"0",opacity:"0"}}> 
              
              <div >{chooseMessage}</div>
              </div>

   }

{selectedTab != "Layout"&&
        <div className="cat-chip-row">
     
         <button
            onClick={()=>{
                
                    if(selectedTab==="Fonts")
                        setSelectedFontCategories([]);
                    else if(selectedTab==="Images")
                        setSelectedImageCategories([]);
                    else if(selectedTab==="Colors")
                        setSelectedColorCategories([]);

                   reloadSetDataWithFilters(selectedSetType,[]);
                }
            }
            style={{animationDelay:"0s",opacity:"0"}}
            type='button' role = 'tab' key={selectedTab}  className={"cat-chip all vanimation-fade-in-right " + (SelectedCatagories().length==0?"selected":"")}>
             {(selectedSetType===SetType.Image)?"All Industries":"All"}
             </button>
 {
     CurrentAvailabelCats().map((cat:any,i)=>{


        if(selectedSetType === SetType.Image){

            if(i==6){ // more button
               return <button
               
                key = {i}
                onClick={()=>{



                    OpenBusinessTypePopup("Select Business Types","Select the business types you want to see images for.",allBusinessTypes,selectedImageCategories,(cats:string[])=>{
                        setSelectedImageCategories(cats);
                        reloadSetDataWithFilters(selectedSetType,cats);

                    });

          
                    
                }}
                style={{animationDelay:(i*.1)+"s",opacity:"0"}}
                type='button' role = 'tab' className={"cat-chip more vanimation-fade-in-right "+(moreSelected?"selected":"")}>
                 {"More..."}
                 </button>
     
            }

            else if( i>6){
                return null;
            }
            
        }
         const selected = SelectedCatagories().includes(cat.id)?"selected":"";

         return <button

            key = {cat.id}
            onClick={()=>{
                if(SelectedCatagories().includes(cat.id)){
                    let cats = SelectedCatagories().filter((c)=>c!==cat.id);
                    if(selectedTab==="Fonts")
                        setSelectedFontCategories(cats);
                    else if(selectedTab==="Images")
                        setSelectedImageCategories(cats);
                    else if(selectedTab==="Colors")
                        setSelectedColorCategories(cats);

                   reloadSetDataWithFilters(selectedSetType,cats);
                }
                else{
                    let cats = [...SelectedCatagories(),cat.id];
                    if(selectedTab==="Fonts")
                        setSelectedFontCategories(cats);
                    else if(selectedTab==="Images")
                        setSelectedImageCategories(cats);
                    else if(selectedTab==="Colors")
                        setSelectedColorCategories(cats);

                    reloadSetDataWithFilters(selectedSetType,cats);
                }


             
                
            }}

            style={{animationDelay:(i*.1)+"s",opacity:"0"}}
            type='button' role = 'tab' className={"cat-chip vanimation-fade-in-right "+selected}>
             {cat.name}
             </button>
         
     })
 }

 </div>
}
 {!userContext.current.isAdmin&&!isProApp&&
            <>
              
                   <div className="align-center flex-row justify-start gap-med vanimation-fade-in " key={selectedTab} style={{fontWeight:400,fontSize:"16px",lineHeight:"20px",padding:"20px 0px",animationDelay:"0",opacity:"0"}}> 
              
                    <div > <b>{stepMessage}</b>{chooseMessage}</div>
                    </div>
          

            </>
        }
 
 
 {userContext.current.isAdmin&&
            <AdminFilterTab filterOpen={adminFilterOpen} setFilterOpen={setAdminFilterOpen} showPrivate={showPrivate} setShowPrivate={setShowPrivate} showPublic={showPublic} setShowPublic={setShowPublic} />}
            </div>
        
            {/* <div id="set-content-container flex-row" style={{ height:"10px",display:"flex",flexGrow:100}}> */}
                <div className=" set-grid-left">
                <div className="set-main-content " ref={contentContainerRef} >
                <DndContext
                            sensors={sensors}
                            collisionDetection={closestCenter}
                            onDragStart={handleDragStart}
                            onDragEnd={handleDragEnd}
                            onDragCancel={handleDragCancel}
                        >

                            <SortableContext
                       
                                items={ ((selectedTab==="Fonts")?allFonts:(selectedTab==="Images")?allImages:allColors).filter((set:StyleSet) => {
                                    if((set.isPrivate&&!showPrivate) || (!set.isPrivate&&!showPublic))
                                        return false;
                                    return true;
                                
                                })}
                                strategy={rectSortingStrategy}

                            >
                    {selectedTab === "Generator" &&
                        <FontGenerator/>
                    }
                    { selectedTab === "StyleList" &&
                        <button onClick={loadAllStyleSetData}>{loadingString}</button>
                    }

                    {selectedTab === "Colors"&&

                       filteredSets.map((colorSet,i) => {
                            colorSet.index = i;
                          
                            
                            const selected = selectedColors.id === colorSet.id;

                            return <SetCard 
                            animationDelay= {(i*.025)+"s"}
                            isAdmin = {userContext.current.isAdmin}
                            setType={SetType.Color}
                            styleSet={colorSet} 
                            key={colorSet.id} 
                            selected={selected} 
                            onSelect={()=>{setSelectedColors(colorSet);onMakeSelection()}}
                            onDelete={()=>deleteSet(SetType.Color,colorSet)}
                            onEdit={()=>{
                                OpenSavSetMenu(SetType.Color,colorSet.items,userContext.current,colorSet.id,SetSaveType.EditCategories,colorSet.categories??[],()=>{reloadSetData(SetType.Color)});
       
                            }}
                            onTogglePrivate={(isPrivate:boolean)=>togglePrivate(isPrivate,SetType.Color,colorSet)}
                            
                            > 
                            
                            <ColorSet colors={colorSet.items}/>

                            </SetCard>
            
                        })
                    }
                    {selectedTab === "Images"&&
                
                            filteredSets.map((imageSet,i) => {

                            imageSet.index = i;

                            const selected = selectedImages.id=== imageSet.id;

                            return <SetCard 
                            animationDelay= {(i*.075)+"s"}
                            isAdmin = {userContext.current.isAdmin}
                            setType={SetType.Image}
                            styleSet ={imageSet} key={imageSet.id} selected={selected} 
                            onSelect={()=>{setSelectedImages(imageSet);;onMakeSelection();}}
                            onEdit={()=>{
                                OpenSavSetMenu(SetType.Image,imageSet.items,userContext.current,imageSet.id,SetSaveType.EditCategories,imageSet.categories??[],()=>{reloadSetData(SetType.Image)});
                            }}
                            onDelete={()=>deleteSet(SetType.Image,imageSet)}
                            onTogglePrivate={(isPrivate:boolean)=>togglePrivate(isPrivate,SetType.Image,imageSet)}
                            >  
                            <ImageSet images={imageSet.items} />
                            </SetCard>

                        })
                    }
                    {selectedTab === "Fonts"&&
                        
                

                        filteredSets.map((fontSet,i) => {
                       
                            fontSet.index = i;
                            const selected = selectedFonts.id === fontSet.id;

                            return <SetCard 
                            animationDelay= {(i*.075)+"s"}
                            isAdmin = {userContext.current.isAdmin}
                            setType={SetType.Font}
                            styleSet ={fontSet} key={fontSet.id} selected={selected} 
                            onSelect={()=>{setSelectedFonts(fontSet);onMakeSelection()}}
                            onDelete={()=>deleteSet(SetType.Font,fontSet)}
                            onEdit={()=>{
                                OpenSavSetMenu(SetType.Font,fontSet.items,userContext.current,fontSet.id,SetSaveType.EditCategories,fontSet.categories??[],()=>{reloadSetData(SetType.Font)});
                            }}
                            onTogglePrivate={(isPrivate:boolean)=>togglePrivate(isPrivate,SetType.Font,fontSet)}
                                >
                                <FontSet primary={fontSet.items[0]} secondary={fontSet.items[1]} />
                                </SetCard>

     
                        })
                    }
                    {
                        selectedTab === "Layout"&&
                        <SetLayoutList userContext={userContext.current} colorSet={selectedColors} fontSet={selectedFonts} imageSet={selectedImages} />
                    }
                    </SortableContext>
                </DndContext>
{
    filteredSets.length==0&&<NoSetRecords setType={selectedSetType} />
}

                </div>
                </div>
                {selectedTab != "Layout"&&
                <div className={"set-main-settings flex-row  align-start gap-small justify-center set-grid-right "+(userContext.current.isAdmin?"admin":"")}  >
                {userContext.current.isAdmin&&
                <div className="set-menu-container" style={{width:"300px",borderRadius:"5px",background:"#f7f7f7",padding:"12px 24px",marginTop:"-45px",zIndex:1,marginRight:"-30px",boxShadow:"0 12px 30px 10px #0000001c"}}>
                    {selectedTab === "Colors"&&
                    <> 
                        <h5 className="panel-title">Add Color Palette</h5>
                        <ColorSetMenu key={selectedColors.id??""} allColors={allColors} colors={selectedColors.items} setColors={ (colors,isNew)=>{

                            let newSet = {...selectedColors,items:colors};

                            if(isNew)
                                newSet.id = "n";

                            setSelectedColors(newSet);
                            
                            }}/>
                    </>
                    }
                    {selectedTab === "Fonts"&&
                    <>
                        <h5 className="panel-title">Add Font Pair</h5>
                        <FontSetMenu fonts={selectedFonts.items} setFonts={(fonts)=> setSelectedFonts({...selectedFonts,items:fonts})}/>
                    </>
                    }
                   {selectedTab === "Images"&&
                    <>
                        <h5 className="panel-title">Add Image Set</h5>
                        <p className="font-small">Drag images to change their order</p>
                        <ImageSetMenu key={selectedImages?.id??""} images={[...selectedImages.items]} 
                        
                      
                        setLoading={setIsLoading} setImages={(images)=> setSelectedImages({...selectedImages,items:images})}
                        onProgress={(index:number,progress:number)=>{
                            
                            if(progress == 0&&progressRef.current[index] >= 100){
                                progressCountRef.current++;
                            }
                            else if(progress == 100){
                                let found = false;
                               for(let i = 0;i<progressRef.current.length;i++){
                                   if(i!=index&&progressRef.current[i] < 100){
                                        found = true;
                                        break;
                                   }
                               }

                                 if(!found){
                                  progressCountRef.current=0;
                                 }

                            }

                            let arr = [...progressRef.current]; // use ref to avoid state logic overriding values
                            arr[index] = progress;
                            progressRef.current = arr;
                            setCompressionProgress(arr);


                        }}/>
                    </>
                    }
                    <br/>
             
                    <div className="btn-container flex-column gap-med" style={{padding:"16px 16px",margin:"0 -24px",background:"F8F8F8",borderTop:"1px solid #CDCDCD"}}>
                    <button onClick={()=>{OpenPreview()}} className="w-button w-button-secondary w-full">Preview</button>
                    <div className="flex-row save-row">
                    <button id="save-set-btn" className=" w-button w-button-primary w-full"
                    
                    onClick={()=>{

                        let content = (selectedTab==="Fonts")?selectedFonts.items:(selectedTab==="Images")?selectedImages.items:selectedColors.items;

                        let allItems = (selectedTab==="Fonts")?allFonts:(selectedTab==="Images")?allImages:allColors;

                        let index = allItems.findIndex((set:StyleSet) => {
                            return   content.join(",") == set.items.join(",");
                            
                        });

                        if(index>=0){
                            CustomColorToast("This set is a duplicate","#B42318","#ffffff",<XIcon/>);
                            return;
                        }

                   
                        OpenSavSetMenu(selectedSetType,content,userContext.current,undefined,SetSaveType.Create,undefined,()=>{reloadSetData(selectedSetType)});

                    }}
                    
                    >Save Set</button>
                    {SelectedSet()&& (SelectedSet()?.id??"").length>5&&
                    <Dropdown>
                        <Dropdown.Toggle variant="" as="a" bsPrefix="update-save-dropdown w-button w-button-primary" id="dropdown-basic"> <DownCaret/> </Dropdown.Toggle>
                        <Dropdown.Menu >
                            <Dropdown.Item  onClick={() => { updateSet();}}>Update Set</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
}
                    </div>
                       
                    </div>
                </div>
                }
                
                <div  className="flex-column gap-small set-preview-container" style={{marginTop:(userContext.current.isAdmin?"-10px":"8px" )}}>
        
                    <CreateStylePreviewImage canvasWidth={"100%"} canvasHeight={"360px"} image = {selectedImages.items[0]} colors={selectedColors.items} fontPrimary={selectedFonts.items[0]} fontSecondary={selectedFonts.items[1]}/>
                
     
                    {allColors.length>0&&allFonts.length>0&&allImages.length>0&&<>
                    <button 
                        className="w-button w-button-ghost w-full"
                        onClick={()=>{
                            setSelectedColors(allColors[Math.floor(Math.random()*allColors.length)]);
                            setSelectedImages(allImages[Math.floor(Math.random()*allImages.length)]);
                            setSelectedFonts(allFonts[Math.floor(Math.random()*allFonts.length)]);


                        }}  
                    
                    >Generate Combination</button>

                    </>
                    
                    }
                    </div> 
                        
  
                 </div>
                }
                   

         
              
            {/* </div> */}
            {!userContext.current.isAdmin&&
            <div className="set-grid-bottom">
         <div className="flex-row gap-med justify-end button-row" style={{padding:"8px"}} >
           
           { selectedTab != "Colors"&&
            <button className="w-button w-button-secondary" style={{width:"160px"}} onClick={PrevTab} >Back</button>
           }
            { selectedSetType != SetType.Font&&selectedTab!="Layout"&&
             <button disabled={isProApp&&SelectedSet()?.id.length<3} className="w-button w-button-primary" style={{width:"160px"}} onClick={NextTab} >Next</button>
            }
            { selectedSetType === SetType.Font&& ((selectedFonts.id.length>3&& selectedImages.id.length>3&& selectedColors.id.length>3)||isProApp)&&
             <button disabled={isProApp&&(selectedFonts.id.length<=3|| selectedImages.id.length<=3|| selectedColors.id.length<=3)} className="w-button w-button-primary"  style={{minWidth:"160px"}} onClick={()=>{setSelectedTab("Layout")}} >Choose Layout</button>
            }
            </div>
            </div>
         }
        </div>
        
        </div>

 
        </>
    )
}

export function NoSetRecords({setType}:{setType:SetType}) {
let str = "Fonts";
let icon = <></>
switch(setType){
    case SetType.Color:
        icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height={"2em"}><path d="M464 258.2c0 2.7-1 5.2-4.2 8c-3.8 3.1-10.1 5.8-17.8 5.8H344c-53 0-96 43-96 96c0 6.8 .7 13.4 2.1 19.8c3.3 15.7 10.2 31.1 14.4 40.6l0 0c.7 1.6 1.4 3 1.9 4.3c5 11.5 5.6 15.4 5.6 17.1c0 5.3-1.9 9.5-3.8 11.8c-.9 1.1-1.6 1.6-2 1.8c-.3 .2-.8 .3-1.6 .4c-2.9 .1-5.7 .2-8.6 .2C141.1 464 48 370.9 48 256S141.1 48 256 48s208 93.1 208 208c0 .7 0 1.4 0 2.2zm48 .5c0-.9 0-1.8 0-2.7C512 114.6 397.4 0 256 0S0 114.6 0 256S114.6 512 256 512c3.5 0 7.1-.1 10.6-.2c31.8-1.3 53.4-30.1 53.4-62c0-14.5-6.1-28.3-12.1-42c-4.3-9.8-8.7-19.7-10.8-29.9c-.7-3.2-1-6.5-1-9.9c0-26.5 21.5-48 48-48h97.9c36.5 0 69.7-24.8 70.1-61.3zM160 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-64a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm128-64a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm64 64a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>
        str = "Color Palettes";
        break;
    case SetType.Image:
        icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" height={"2em"}><path d="M160 80H512c8.8 0 16 7.2 16 16V320c0 8.8-7.2 16-16 16H490.8L388.1 178.9c-4.4-6.8-12-10.9-20.1-10.9s-15.7 4.1-20.1 10.9l-52.2 79.8-12.4-16.9c-4.5-6.2-11.7-9.8-19.4-9.8s-14.8 3.6-19.4 9.8L175.6 336H160c-8.8 0-16-7.2-16-16V96c0-8.8 7.2-16 16-16zM96 96V320c0 35.3 28.7 64 64 64H512c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H160c-35.3 0-64 28.7-64 64zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120V344c0 75.1 60.9 136 136 136H456c13.3 0 24-10.7 24-24s-10.7-24-24-24H136c-48.6 0-88-39.4-88-88V120zm208 24a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z"/></svg>
        str = "Image Sets";
        break;
    case SetType.Font:
        icon = <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height={"2em"}><path d="M0 88C0 39.4 39.4 0 88 0H392c30.9 0 56 25.1 56 56V344c0 22.3-13.1 41.6-32 50.6V464h8c13.3 0 24 10.7 24 24s-10.7 24-24 24H80c-44.2 0-80-35.8-80-80c0-2.7 .1-5.4 .4-8H0V88zM80 400c-17.7 0-32 14.3-32 32s14.3 32 32 32H368V400H80zM48 358.7c9.8-4.3 20.6-6.7 32-6.7H392c4.4 0 8-3.6 8-8V56c0-4.4-3.6-8-8-8H88C65.9 48 48 65.9 48 88V358.7zM261.5 93.3l88 176c5.9 11.9 1.1 26.3-10.7 32.2s-26.3 1.1-32.2-10.7L289.2 256c-.4 0-.8 0-1.2 0H192c-.4 0-.8 0-1.2 0l-17.4 34.8c-5.9 11.9-20.3 16.7-32.2 10.7s-16.7-20.3-10.7-32.2l88-176C222.6 85.1 230.9 80 240 80s17.4 5.1 21.5 13.3zM265.2 208L240 157.7 214.8 208h50.3z"/></svg>
        str = "Font Pairs";
        break;
}

    return <div className="flex-column align-center justify-center gap-med" style={{height:"80%",width:"100%",fontWeight:600}}>
        {icon}
        {`No ${str} Found`}
         </div>


}

export function ColorSet({colors,overridHeight}:{colors:string[],overridHeight?:string}) {

    if(!colors || colors.length<0){
        return null;
    }
    return (
        <div className="color-row" style={{height:overridHeight??"48px"}}>
            {colors.map((color,index) => {
                if(index>4)
                    return null;

                return <div key={index} style={{background:color,width:"100%",height:overridHeight??"48px"}}></div>
            })}
        </div>
    )
}

function SetCard({selected,children,onSelect,styleSet,setType,onDelete,onTogglePrivate,onEdit,isAdmin,animationDelay}:{animationDelay?:string, setType:SetType,selected:boolean,children:React.ReactNode,onSelect:()=>void,onDelete:()=>void,onEdit:()=>void,onTogglePrivate:(isPrivate:boolean)=>void,styleSet:StyleSet,isAdmin?:boolean}) {


    const {
        isDragging,
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: styleSet.id });

    
    const style = {

        opacity: (animationDelay&&!isAdmin?"0":"1"),
        animationDelay:animationDelay??undefined,
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition: transition ?? undefined,
        zIndex: isDragging ? 5 : undefined,
    };

    return <div id={styleSet.id} ref={setNodeRef} style={style} className={"set-card  cursor-pointer  "+(selected?"selected":"")+(isAdmin?"":" vanimation-fade-in-up")+(setType===SetType.Image?" image-set ":"")}  onClick={onSelect} >
        <div className="set-card-inner relative">
        {children}
        {isAdmin&&<>
        <div className="set-card-num">{(styleSet?.index??0)+1}</div>
      
        <div className="set-card-overlay">
            <div className="flex-row justify-between" style={{padding:"4px",fontSize:"28px"}}>
               <div className="icon drag"  {...attributes} {...listeners}> <HamburgerIcon/></div>
                
                <Dropdown>
                    <Dropdown.Toggle variant="" as="a" bsPrefix=" menu-dot-dropdown " id="dropdown-basic">
                    <div  className="icon dots"><MenuDots/></div>
                    </Dropdown.Toggle>
        
                <Dropdown.Menu>
                    <Dropdown.Item  onClick={() => {onEdit();  }}>Edit Settings</Dropdown.Item>
                    <Dropdown.Item  onClick={() => { onTogglePrivate(!styleSet.isPrivate) }}>{styleSet.isPrivate?"Set Public":"Set Private"}</Dropdown.Item>
                    <Dropdown.Item  onClick={() => { onDelete() }}>Delete</Dropdown.Item>
            
                </Dropdown.Menu>
            
            </Dropdown>
                </div>
            </div></>}
        </div>
        {styleSet.isPrivate&&<div className="flex-row justify-end"><div className="private-tag">Private</div></div>}
                            

        
    </div>


}

export function ImageSet({images}:{images:string[]}) {


      if(!images)
        return null;

    return <div style={{width:"100%",display:"flex",flexDirection:"row",flexWrap:"wrap",borderRadius:"5px",overflow:"hidden",border:"1px solid #eee"}}>
        {images.map((image,index) => {
            if(index>3){
                return null;
            }
            let url = image;


            return <div key={index}  style={{ backgroundImage:`url(${url})`,backgroundPosition:"center", borderRight:(index%2==0?"1px solid white":"none"),borderTop:(index>1?"1px solid white":"none"),backgroundSize:"cover",width:"50%",paddingBottom:"50%"}}>



            </div>
       
        })}
        </div>

}
const imgURLRoot = `${process.env.PUBLIC_URL}/fontpreviews/`;

export function FontSet({primary,secondary,padding}:{primary:string,secondary:string,padding?:string}) {

    if(!primary||!secondary){
        return null;
    }

    const imgFileA = primary.replaceAll(" ", "-").toLowerCase() + ".png";
    const imgFileB = secondary.replaceAll(" ", "-").toLowerCase() + ".png";
    const imgURLA = `${imgURLRoot}${imgFileA}`;
    const imgURLB = `${imgURLRoot}${imgFileB}`;

    const height = 28;

    return <div style={{width:"100%",borderRadius:"5px",border:"1px solid #CDCDCD",padding:padding??"28px",background:"white"}}>
        <div style={{position:"relative"}}>
          <img src={imgURLA} height={height}  alt='font'/>
          <img
            loading="lazy"
            alt='font'
            src={imgURLA}
            height={height}
            style={{ position: "absolute", left: "1px", bottom: 0 }}
          />
          <span style={{ display: "none" }}>{primary}</span>
        </div>
        <div style={{height:"6px"}}></div>
        <div>
          <img alt='font' src={imgURLB} height={height} loading="lazy" />
          <span style={{ display: "none" }}>{secondary}</span>
        </div>

    </div>
}


const colorLabels =["Darkest","Dark","Medium","Light","Lightest"];

function ColorSetMenu({colors,setColors,allColors}:{allColors:StyleSet[],colors:string[],setColors:(colors:string[],isNew?:boolean)=>void} ){

    const atts = new AttributeCollection();

    for(let i = 0;i<colors.length;i++){
        let label = colorLabels[i]??"err";
        setNodeComponentAttributeValue(atts,label,colors[i]);

    }

    return <>< div className="condensed-pickers">
    {colorLabels.map((label,index) => {
        const def = new AttributeDefinition(label,label,"",AttributeInputType.ColorField);
        def.targetType = AttributeTargetType.Component;
        
        return <ColorInputField key={index} definition={def} hidePallet={true} label={label} screenSize={0} layoutObject={atts} siteData={DefaultSiteData} updateFunc={(att: string, val: string) => {

            setNodeComponentAttributeValue(atts,label,val);
            let newColors = colorLabels.map((label) => {
                return getNodeComponentAttributeValue(atts,label);
            });
            setColors(newColors);
        } } saveFunc={()=>{}} />

    })}

    </div>
  
    {allColors.length>0&&
    <div className="flex-row" style={{marginTop:"12px"}}>
               {/* <button
               className="w-button w-button-ghost w-full"
                onClick={()=>{
                    let data = {...DefaultSiteData}
                    let styling = {...DefaultSiteData.siteStyling};
                    styling.colorPallet = [...styling.colorPallet];
                    for(let i = 0;i<colors.length;i++){
                        styling.colorPallet[i] = colors[i];
                    }

                    data.siteStyling = styling;
                    OpenADAPopup(data);
                }}
                >ADA Compliance</button> */}
    <button className="w-button w-button-ghost w-full" 
    onClick={()=>{
        
        
        setColors(RandomColorPalletFromOtherSets(allColors),true)}}
    >Randomize Pallet</button>
    </div>
    }
    </>



}


function FontSetMenu({fonts,setFonts}:{fonts:string[],setFonts:(fonts:string[])=>void} ){ 

const fontAtts = new AttributeCollection();
fontAtts.componentAttributes = {primary:fonts[0],secondary:fonts[1]};

const options = GetFontOptions(DefaultSiteData);

const primaryDef = new AttributeDefinition("primary","Heading","",AttributeInputType.SelectField);
primaryDef.options = options;
primaryDef.targetType = AttributeTargetType.Component;

const secondaryDef = new AttributeDefinition("secondary","Body","",AttributeInputType.SelectField);
secondaryDef.options = options;
secondaryDef.targetType = AttributeTargetType.Component;


return <>
 <SelectField definition={primaryDef} layoutObject={fontAtts} label={"Headings"} allowFilter={true} extraClass="no-border neg-mb-16"  screenSize={0} siteData={DefaultSiteData} updateFunc={(att: string, val: string) => {

    setNodeComponentAttributeValue(fontAtts,"primary",val);
    setFonts([val,getNodeComponentAttributeValue(fontAtts,"secondary")]);
 } } saveFunc={()=>{}}/>
 <SelectField definition={secondaryDef} layoutObject={fontAtts} label={"Body"} allowFilter={true}  screenSize={0} siteData={DefaultSiteData} updateFunc={(att: string, val: string) => {

    setNodeComponentAttributeValue(fontAtts,"secondary",val);
    setFonts([getNodeComponentAttributeValue(fontAtts,"primary"),val]);
} } saveFunc={()=>{}}/>
<br/>
    <FontSet primary={fonts[0]} secondary={fonts[1]}/>
</>

}

const compressImage = async (file:File,onComplete:(img:File)=>void,index:number,onProgress:(inx:number,prog:number)=>void) => {
 
    onProgress(index,0);

    const options = {
      maxSizeMB: 1,
      maxWidthOrHeight: 2048,
      useWebWorker: true,
      onProgress: (p: number) => { onProgress(index,p);}
    };
   let img = await imageCompression(file, options);
    onComplete(img);
    

  };

const validTypes = [
    'image/png','image/jpeg','image/jpg','image/gif','image/svg+xml','image/webp'
]
const invalidMessage = "Invalid file type, please upload a valid image.";

function ImageSetMenu({images,setImages,setLoading,onProgress}:{images:string[],setImages:(images:string[])=>void,setLoading:(on:boolean)=>void,onProgress:(index:number,progress:number)=>void} ){

    const sensors = useSensors(
        useSensor(PointerSensor),
        useSensor(KeyboardSensor, {
            coordinateGetter: sortableKeyboardCoordinates,
        })
    );
    
    const [snapKey,setSnapKey] = useState<number>(0);
    const ref1 = useRef<HTMLInputElement>(null);
    const ref2 = useRef<HTMLInputElement>(null);
    const ref3 = useRef<HTMLInputElement>(null);
    const ref4 = useRef<HTMLInputElement>(null);
    const ids = [1,2,3,4];
    const refs = [ref1,ref2,ref3,ref4];

    const [urls,setURLS] = useState<string[]>(images);

    function UploadAllImages(refs:any[],index:number , event:any, onComplete:(images:string[])=>void){
    

        const selectedFiles = (event.target as HTMLInputElement).files;

        if(selectedFiles&&selectedFiles.length>1){

            const completed = {
                count:0
            }

            

            for (let i = 0; i < selectedFiles.length&&i<refs.length; i++) {
                let ref = refs[i];
    
                if(ref.current){
                    if(selectedFiles[i]){

                    
                        if(!validTypes.includes(selectedFiles[i].type)){
                            AlertConfirm(invalidMessage);
                            return;
                        
                        }

                        setLoading(true);
                    
                        compressImage(selectedFiles[i],(img:File)=>{
                  
                            const file = new File([img], img.name, { type: img.type });
                            let dataTransfer = new DataTransfer();
                            dataTransfer.items.add(file);
                            ref.current.files = dataTransfer.files;
                            completed.count++;  
                            if(completed.count>=selectedFiles.length||completed.count>=refs.length){
                                setLoading(false);
                            }
                            readImage(file,i);
                        },i,onProgress);
                      
                        
                       
                    
                    }
                }
            }
        }
        else if(selectedFiles&&selectedFiles.length>0){


            onUpload(refs[index].current,index);
        }
    
        // for (let i = 0; i < selectedFiles.length; i++) {
        //   const fileReader = new FileReader();
        //   const file = selectedFiles[i];
    
        //   fileReader.onload = (e) => {
        //     // You can perform additional operations like validation here if needed
        //     if(e.target?.result)
        //     imageArray.push({ file: file, src: e.target.result });
        //     if (imageArray.length === selectedFiles.length) {
       
        //       onComplete(imageArray);
        //     }
        //   };
    
        //   fileReader.readAsDataURL(file);
        // }
    }
    const readImage  = (file:any,index:number) => {
        var reader = new FileReader();
        reader.onload = function (e) {
            let url = e.target?.result;
            if(url){
              
                urls[index] = url as string;

                setURLS([...urls]);
                setImages([...urls]);
            }
        }
        reader.readAsDataURL(file);
    }
    const onUpload = (fileInput:any,index:number) => {
       
        if(fileInput.files[0]){
        
            if(!validTypes.includes(fileInput.files[0].type)){
                AlertConfirm(invalidMessage);
                return;
            
            }

            setLoading(true);
         
            compressImage(fileInput.files[0],(img:File)=>{
            
        var reader = new FileReader();
   
        reader.onload = function (e) {
            let url = e.target?.result;
            if(url){
          
                urls[index] = url as string;
               
                setURLS([...urls]);
                setImages([...urls]);
                setLoading(false);
            }
        }

        reader.onerror = function (e) {
            setLoading(false);
            AlertConfirm("Error uploading image, please try again");
        }

        reader.onabort = function (e) {
            setLoading(false);
            AlertConfirm("Error uploading image, please try again");
        }
        
        reader.readAsDataURL(img);
 
    },index,onProgress);

    }

    }
    
    const handleDragStart = useCallback((event: DragStartEvent) => {}, []);
    const handleDragCancel = useCallback(() => {}, []);
    const handleDragEnd = (event: DragEndEvent) => {

        const { active, over } = event;

    

        if (active.id !== over?.id) {

            const oldIndex = ids.findIndex((item) => item === active.id);
            let newIndex = ids.findIndex((item) => item === over?.id);

            

            if(newIndex>=0&&oldIndex>=0){



                 let newRefs = arrayMove(refs, oldIndex, newIndex);
                let newURLS = arrayMove(urls, oldIndex, newIndex);

                let fileList = newRefs.map((ref) => { return ref.current?.files??null; });
               
                setTimeout(()=>{    for(let i = 0;i<fileList.length;i++){

                    let file =fileList[i];
                    
                    let current = refs[i].current;
                    if(current)
                    current.files = file??null;
                  
               }},100);
            

                setURLS(newURLS);
                setImages(newURLS);
                setSnapKey(snapKey+1);


            }
            
        }




    };

   return <>
   <div className="flex-row flex-wrap" style={{}}>


   <DndContext
    sensors={sensors}
    collisionDetection={closestCenter}
    onDragStart={handleDragStart}
    onDragEnd={handleDragEnd}
    onDragCancel={handleDragCancel}
>

        <SortableContext
    
            items={ids}
            strategy={rectSortingStrategy}

        >
   {refs.map((ref,index) => {
        let image = index<urls.length?urls[index]:"";
        // let imgNum = "one";
        // if(index==1)
        //     imgNum = "two";
        // else if(index==2)
        //     imgNum = "three";
        // else if(index==3)
        //     imgNum = "four";

                return <DraggableImage  allRefs={refs} inref={ref} key={index+":"+snapKey} url={image} index={index} onUpdate={UploadAllImages} setImages={setImages}/>


   })}
    </SortableContext>
    </DndContext>
   </div>
   </>
 
}

function DraggableImage({allRefs,inref,url,index,onUpdate,setImages }:{allRefs:any[],url:string,inref:any, index:number, onUpdate:Function,setImages:Function}){


    const {
        isDragging,
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition
    } = useSortable({ id: index+1 });

    const style = {
        transform: transform ? `translate3d(${transform.x}px, ${transform.y}px, 0)` : undefined,
        transition: transition ?? undefined,
        zIndex: isDragging ? 5 : undefined,
    };


   return <div {...attributes}  {...listeners}  className="relative image-upload-container" ref={setNodeRef}  style={{...style,...{backgroundImage:"url("+url+")"}}}> 
                    <input type="file" title=" " accept="image/png, image/gif, image/jpeg, image/webp" ref={inref} className="set-file"  id="myFile" name="filename" multiple onChange={(e)=>onUpdate(allRefs,index, e,setImages)}/>
                    <div className="image-overlay center-all">
                        Upload Image
                    </div>
                    <div   className={"image-num "} >{index+1}</div>
                </div>
        
}

function AdminFilterTab(
    {showPublic,showPrivate,setShowPublic,setShowPrivate,filterOpen, setFilterOpen}:
    {showPublic:boolean,showPrivate:boolean,setShowPublic:(val:boolean)=>void,setShowPrivate:(val:boolean)=>void,filterOpen:boolean,setFilterOpen:(val:boolean)=>void}){
  
     
  
    const clickOutside = (e:any)=>{
      if(!e.target.closest(".filter-tab")){
        setFilterOpen(false);
      }
    }
  
    useEffect(() => {
  
      window.addEventListener("click",clickOutside);
      return () => {
        window.removeEventListener("click",clickOutside);
      }
      //eslint-disable-next-line
    }, [])
  
   return <div className="filter-tab relative"  style={{zIndex:"500",width:"fit-content"}}>
      <div style={{width:"200px",margin:"12px 8px"}} className="flex-row gap-med center-all relative cursor-pointer justify-start" onClick={()=>setFilterOpen(!filterOpen)}><div style={{fontSize:"16px",fontWeight:600}}>Filter</div> <div style={{fontSize:".8em",marginTop:"-2px"}}><DownCaret/></div> </div>
      {
        filterOpen&&<div className="flex-column w-full" style={{zIndex:250,position:"absolute",width:"200px",top:"100%",left:"0px",background:"white",borderRadius:"4px",boxShadow:"0 3px 10px 10px #00000010",padding:"4px 0px 4px"}}>
          <div className="gray-hover" style={{padding:"0 8px"}}><CheckItem styling={{height:"44px",paddingRight:"40px"}} item="Public" checked={showPublic} onClickFunc={(e)=>{ e.stopPropagation(); setShowPublic(!showPublic)}} /></div>
          <div className="gray-hover" style={{padding:"0 8px"}}><CheckItem styling={{height:"44px",paddingRight:"40px"}} item="Private" checked={showPrivate} onClickFunc={(e)=>{e.stopPropagation(); setShowPrivate(!showPrivate)}} /></div>
        </div>
      }
    </div>
  
    }

function MenuDots(){

    return <svg xmlns="http://www.w3.org/2000/svg" height="1em" fill="currentColor" viewBox="0 0 128 512"><path  d="M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z"/></svg>
  }
  
function RandomColorPalletFromOtherSets(allColors:StyleSet[] ){


    let colors:string[] = []

    for(let i = 0;i<5;i++){

        let rndm = Math.floor(Math.random()*allColors.length);

        let set= allColors[rndm];
        if(set.items.length>i)
        colors.push(set.items[i]);

    }

    return colors;
}

// function HSLRandomColorPallet(){

//     let colors:string[] = []
//     let sat = Math.floor(Math.random()*100);

//     for(let i = 0;i<5;i++){

//         let rndmHue = Math.floor(Math.random()*360);
//         let light = i*20+10;

 
    
//         colors.push(hslToHex(rndmHue,sat - i*10,light));

//     }

//     return colors;
// }
// function hslToHex(h:number, s:number, l:number) {
//     l /= 100;
//     const a = s * Math.min(l, 1 - l) / 100;
//     const f =( n:any )=> {
//       const k = (n + h / 30) % 12;
//       const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
//       return Math.round(255 * color).toString(16).padStart(2, '0');   // convert to Hex and prefix "0" if needed
//     };
//     return `#${f(0)}${f(8)}${f(4)}`;
//   }


  function CircleCheck({isVisible}:{isVisible:boolean}){
        if(!isVisible){
            return<div className="set-check-mark" style={{transform:"scale(1)"}} > 
            <svg xmlns="http://www.w3.org/2000/svg" fill="#33333355"  viewBox="0 0 512 512"><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"/></svg>
            </div>;
        }
        else{
            return <div className="vanimation-grow set-check-mark" >
                <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" height={"1em"} viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209L241 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L335 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg></div>
        }
  }

//   function CircleOne(){
//     return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512"><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM241.8 128l-5.4 3L176 164.5v54.9l11.7-6.5L232 188.3V336H176v48h80 80V336H280V152 128H256h-8-6.2z"/></svg>
//   }

//   function CircleTwo(){
//     return <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 512 512"><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM222.7 184.7c7.2-5.5 16.1-8.4 25.3-8.3l3.4 .1c20.3 .3 36.6 16.8 36.6 37.1c0 10.3-4.2 20.1-11.7 27.1L167.6 342.5c-7.2 6.7-9.5 17.2-5.9 26.3S174.2 384 184 384H328c13.3 0 24-10.7 24-24s-10.7-24-24-24H244.7l64.4-60.4C326.3 259.5 336 237 336 213.5c0-46.5-37.3-84.4-83.8-85.1l-3.4-.1c-19.9-.3-39.3 6.1-55.1 18.1l-24.2 18.4c-10.5 8-12.6 23.1-4.5 33.6s23.1 12.6 33.6 4.5l24.2-18.4z"/></svg>
//   }

//   function CircleThree(){
//     return <svg xmlns="http://www.w3.org/2000/svg"  fill="currentColor" viewBox="0 0 512 512"><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM184 128c-13.3 0-24 10.7-24 24s10.7 24 24 24h66.3l-50.5 46.3c-7.3 6.7-9.7 17.2-6.1 26.5s12.6 15.3 22.5 15.2l51.5-.3c20.1-.1 36.4 16.1 36.4 36.2c0 20-16.2 36.2-36.2 36.2H240c-13.5 0-26-7-33-18.4l-2.6-4.2c-7-11.3-21.8-14.8-33-7.8s-14.8 21.8-7.8 33l2.6 4.2C182 368.4 209.9 384 240 384h27.8c46.5 0 84.2-37.7 84.2-84.2c0-43.3-32.6-78.9-74.6-83.6l50.8-46.5c7.3-6.7 9.7-17.2 6.2-26.4s-12.5-15.3-22.4-15.3H184z"/></svg>

//   }

//   function GetCircleIcon({setType}:{setType:SetType}){
//         if(setType == SetType.Color){
//             return <CircleOne/>
//         }
//         else if(setType == SetType.Image){
//             return <CircleTwo/>
//         }
//         else if(setType == SetType.Font){
//             return <CircleThree/>
//         }
//         else{
//             return <CircleOne/>
//         }

//   }